import React from "react";

const Calendar: React.FC = () => {
  return <>CALENDAR PAGE</>;
};

export default Calendar;
